import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Link,
  Stack,
  IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import AlertMessage from "../../components/common/AlertMessage";
import ForgotPasswordPageAPI from "../../utils/services/forgotPassword.api";
import {
  emailIDMasking,
  loginVariableSetting,
  setStorageValue,
} from "../../utils/helper";
import "../../styles/LoginPage.css";
import loginAPIMethod from "../../utils/services/login.api";
import { useAuth } from "../../utils/AuthContext";
import NotificationsListAPI from "../../utils/services/notifications.api";
import Loaders from "../../components/common/Loaders";
import { ReactComponent as EditIcon } from "../../assets/logos/edit_home_page.svg";
import useDeviceDetect from "../DeviceDetector";

function ValidateOTPPage(params) {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { userEmailId, userMobNo, showMobilePage } = params;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [copiedOTP, setCopiedOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const { checkUnreadNotifications } = NotificationsListAPI;
  const { validateOTPForgotPassword, generateOTPForgotPassword } =
    ForgotPasswordPageAPI;
  const { verifyMobileOTP, sendMobileOTP } = loginAPIMethod;
  const [timer, setTimer] = useState(60);
  const isMobile = useDeviceDetect();

  const timeOutCallback = useCallback(() => {
    if (userMobNo) {
      setTimer((currTimer) => currTimer - 1);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const formik = useFormik({
    initialValues: {
      otp1: undefined,
      otp2: undefined,
      otp3: undefined,
      otp4: undefined,
      otp5: undefined,
      otp6: undefined,
    },
    onSubmit: async (values) => {
      if (userEmailId) {
        setLoading(true);
        const response = await validateOTPForgotPassword({
          email: userEmailId,
          otp: Object.values(values).join(""),
        });
        if (response.status === "success") {
          setLoading(false);
          navigate("/SetPassword", { state: { emailId: userEmailId } });
        } else if (response.status === "error") {
          setLoading(false);
          setOpen(true);
          setMessage(response.message);
          setSeverity(response.status);
        }
      } else if (userMobNo) {
        setLoading(true);
        const response = await verifyMobileOTP({
          countryCode: "+1",
          phoneNumber: userMobNo,
          otp: Object.values(values).join(""),
        });
        if (response.status === "success") {
          login();
          loginVariableSetting(response?.data);
          getUnreadNotification(response.data.id);
          setStorageValue("menuName", "My Delivery");
          navigate("/MyDelivery");
          setLoading(false);
        } else if (response.status === "error") {
          setLoading(false);
          if (response?.error?.response?.data?.message === "User not found.") {
            navigate("/CompleteProfile", {
              state: { phoneNumber: userMobNo },
            });
          } else {
            setOpen(true);
            setMessage(response.message);
            setSeverity(response.status);
          }
        }
      }
    },
  });
  const handleClose = () => {
    setOpen(false);
  };

  const getUnreadNotification = async (userId) => {
    const checkDate = new Date()?.toISOString();
    const response = await checkUnreadNotifications(userId, checkDate);
    if (response.status !== "success") {
      localStorage.setItem("notifications", false);
    } else {
      if (localStorage.getItem("isClicked") !== "true") {
        localStorage.setItem("notifications", response?.data?.message);
        localStorage.setItem("isReload", response?.data?.message);
      }
    }
  };

  useEffect(() => {
    if (copiedOTP) {
      let i = 1;
      for (let val in copiedOTP) {
        formik.handleChange({
          target: { name: `otp${i}`, value: copiedOTP[val] },
        });
        i++;
      }
      if (copiedOTP && copiedOTP.length !== 6 && copiedOTP.length > 0) {
        document.getElementById(`otp${copiedOTP.length}`).focus();
      }
    }
    // eslint-disable-next-line
  }, [copiedOTP]);

  useEffect(() => {
    if (copiedOTP.length === 6) {
      document.getElementById("otp6").focus();
    }
    setCopiedOTP("");
    // eslint-disable-next-line
  }, [formik.values.otp6]);

  useEffect(() => {
    localStorage.removeItem("isClicked");
    localStorage.removeItem("isReload");
    localStorage.removeItem("notifications");
    // eslint-disable-next-line
  }, []);

  const onClickResend = async () => {
    for (let i = 1; i < 7; i++) {
      formik.handleChange({
        target: { name: `otp${i}`, value: "" },
      });
    }
    if (userEmailId) {
      const response = await generateOTPForgotPassword(userEmailId);
      if (response.status === "success") {
        setMessage("Verification code sent successfully");
        setSeverity("success");
        setOpen(true);
      } else if (response.status === "error") {
        setMessage(response.message);
        setSeverity(response.status);
        setOpen(true);
      }
    } else if (userMobNo) {
      const otpRequest = {
        countryCode: "+1",
        phoneNumber: userMobNo,
      };
      const response = await sendMobileOTP(otpRequest);
      if (response.status === "success") {
        setTimer(60);
        setMessage("OTP sent successfully");
        setSeverity("success");
        setOpen(true);
      } else if (response.status === "error") {
        setMessage(response.message);
        setSeverity(response.status);
        setOpen(true);
      }
    }
  };

  const isNumberKey = (event, otpBox) => {
    if (
      isNaN(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Enter" &&
      event.key !== "Control" &&
      event.key !== "v"
    ) {
      event.preventDefault();
    } else if (event.key === " ") {
      event.preventDefault();
    } else if (
      event.key === "Backspace" &&
      event.target.value === "" &&
      otpBox
    ) {
      document.getElementById(otpBox).focus();
    }
  };
  const handleOnKeyUp = (event, otpBox) => {
    if (event.target.value === "" && event.key === "Backspace" && !copiedOTP) {
      document.getElementById(otpBox).focus();
    }
  };

  return (
    <Stack sx={{ backgroundColor: "#f7faff" }}>
      {loading && <Loaders />}
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        className="box-element"
      >
        <Box
          sx={{
            display: "grid",
            width: "100%",
            padding: isMobile ? "1.5rem" : "2.5rem",
          }}
        >
          <Box sx={{ paddingBottom: "6rem" }}>
            <img
              src={require("../../assets/logos/a2b-logo.svg").default}
              alt="a2bLogoImage"
              style={{ position: "absolute" }}
              width="82%"
              height="60px"
              onDragStart={(e) => {
                e.preventDefault();
              }}
            />
          </Box>
          <Typography sx={{ fontWeight: "600", color: "#101828" }} variant="h5">
            {userEmailId ? "Enter 6 digit Recovery code" : "Verify your number"}
          </Typography>
          <Typography
            sx={{ marginTop: "1rem", color: "#475467" }}
            variant="body2"
          >
            We have sent a verification code to:
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", color: "#0C68F4" }}
          >
            {userEmailId ? emailIDMasking(userEmailId) : userMobNo}
            {userMobNo && (
              <IconButton
                sx={{ cursor: "pointer", padding: "0px", paddingLeft: "4px" }}
                onClick={showMobilePage}
              >
                <EditIcon width="14px" height="14px" />
              </IconButton>
            )}
          </Typography>
          <Box sx={{ marginTop: "1rem" }}>
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              id="otp1"
              variant="outlined"
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyDown={(e) => isNumberKey(e)}
              onKeyUp={(e) => handleOnKeyUp(e, "otp1")}
              value={formik.values.otp1}
              autoComplete="off"
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp1",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value !== "") {
                  document.getElementById("otp2").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
            />
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              id="otp2"
              variant="outlined"
              autoComplete="off"
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyDown={(e) => isNumberKey(e, "otp1")}
              onKeyUp={(e) => handleOnKeyUp(e, "otp2")}
              value={formik.values.otp2}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp2",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value !== "") {
                  document.getElementById("otp3").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
            />
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              style={{ height: "1rem" }}
              id="otp3"
              variant="outlined"
              autoComplete="off"
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyDown={(e) => isNumberKey(e, "otp2")}
              onKeyUp={(e) => handleOnKeyUp(e, "otp3")}
              value={formik.values.otp3}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp3",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value !== "") {
                  document.getElementById("otp4").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
            />
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              id="otp4"
              variant="outlined"
              autoComplete="off"
              onKeyDown={(e) => isNumberKey(e, "otp3")}
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyUp={(e) => handleOnKeyUp(e, "otp4")}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
              value={formik.values.otp4}
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp4",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value !== "") {
                  document.getElementById("otp5").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
            />
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              id="otp5"
              variant="outlined"
              autoComplete="off"
              onKeyDown={(e) => isNumberKey(e, "otp4")}
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyUp={(e) => handleOnKeyUp(e, "otp5")}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
              value={formik.values.otp5}
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp5",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value !== "") {
                  document.getElementById("otp6").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
            />
            <TextField
              sx={{
                width: "45px",
                marginRight: "0.5rem",
                input: { textAlign: "center" },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }}
              id="otp6"
              variant="outlined"
              autoComplete="off"
              onKeyDown={(e) => isNumberKey(e, "otp5")}
              onPaste={(e) => {
                const val = e.clipboardData.getData("text");
                setCopiedOTP(
                  val
                    .toString()
                    ?.replace(/[^0-9]+/gi, "")
                    .split("")
                );
              }}
              onKeyUp={(e) => handleOnKeyUp(e, "otp6")}
              onInput={(e) => {
                e.target.value = !isNaN(e.target.value) ? e?.target?.value : "";
              }}
              value={formik.values.otp6}
              onChange={(e) => {
                formik.handleChange({
                  target: {
                    name: "otp6",
                    value: e?.target?.value,
                  },
                });
                if (e?.target?.value === "") {
                  document.getElementById("otp6").focus();
                }
              }}
              onFocus={(event) => {
                event.target.setSelectionRange(1, 1);
              }}
              slotProps={{ htmlInput: { maxLength: 1 } }}
            />
          </Box>
          {userMobNo && timer > 0 && (
            <Typography
              sx={{
                marginTop: "1rem",
                fontSize: "14px",
                textAlign: "center",
                color: "#344054",
              }}
            >
              {"Resend OTP in "}
              <span style={{ fontWeight: "900" }}>
                00:{timer >= 10 ? timer : `0${timer}`}
              </span>
            </Typography>
          )}
          {userEmailId && timer === 60 && (
            <Typography
              sx={{
                marginTop: "1rem",
                fontSize: "14px",
                textAlign: "center",
                color: "#344054",
              }}
            >
              {"Didn't receive the email?"}{" "}
              <Button
                variant="text"
                style={{
                  textTransform: "none",
                  color: "#2579CD",
                  fontWeight: "600",
                }}
                onClick={onClickResend}
              >
                Click to resend
              </Button>
            </Typography>
          )}
          {userMobNo && timer === 0 && (
            <Typography
              sx={{
                marginTop: "1rem",
                fontSize: "14px",
                textAlign: "center",
                color: "#344054",
              }}
            >
              {"Didn’t receive a code?"}{" "}
              <Button
                variant="text"
                style={{
                  textTransform: "none",
                  color: "#2579CD",
                  fontWeight: "600",
                }}
                onClick={onClickResend}
              >
                Click to resend
              </Button>
            </Typography>
          )}
          <Button
            variant="contained"
            type="submit"
            style={{
              textTransform: "none",
              marginTop: "1.5rem",
              backgroundColor: "#0C68F4",
            }}
            onClick={formik.handleSubmit}
            disabled={Object.values(formik.values).some((val) => !val)}
          >
            Validate
          </Button>
          {userEmailId && (
            <Link
              sx={{
                marginTop: "1rem",
                maxWidth: "200px",
                margin: "1rem auto",
                color: "black",
                textDecorationColor: "black",
                fontSize: "14px",
                cursor: "pointer",
              }}
              underline="always"
              onClick={(e) => {
                if (severity !== "success") {
                  navigate("/Login");
                } else {
                  e.preventDefault();
                }
              }}
              onDragStart={(e) => {
                e.preventDefault();
              }}
            >
              Back to log in
            </Link>
          )}
        </Box>
      </Box>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Stack>
  );
}

export default ValidateOTPPage;
